import React from 'react';
import { defineMessages, FormattedMessage, useIntl } from 'react-intl';

import { StaticImage } from '@nxte-nl/static-image';

import { versionDependent } from '../../images/versionDependentExport';
import { Typography } from '../Typography/Typography';
import styles from './BusinessPDPOpenFormSection.module.css';

export type Props = {
  isDesktop: boolean;
  locale?: string;
  onModalOpen: () => void;
};

const messages = defineMessages({
  button: {
    id: 'src.components.BusinessPDPOpenFormSection.button',
    defaultMessage: 'Announce offer',
  },
  imageAltText: {
    id: 'src.components.BusinessPDPOpenFormSection.imageAltText',
    defaultMessage: 'Business order?',
  },
});

export const BusinessPDPOpenFormSection = React.memo((props: Props) => {
  const {
    onModalOpen,
    isDesktop,
    locale,
  } = props;

  const intl = useIntl();

  return locale ? (
    <div className={styles.businessPDPOpenFormSection}>
      <StaticImage
        width={142}
        alt={intl.formatMessage(messages.imageAltText)}
        src={versionDependent[
          isDesktop ? 'pdpBusinessLogo' : 'mobilePdpBusinessLogo'][locale]}
        className={styles.pdpBusinessLogo}
      />
      <button
        className={styles.button}
        onClick={onModalOpen}
      >
        <Typography
          className={styles.buttonText}
          variant='bodySubText1'>
          <FormattedMessage {...messages.button} />
        </Typography>
      </button>
    </div>
  ) : null;
});

BusinessPDPOpenFormSection.displayName = 'BusinessPDPOpenFormSection';
